"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cart = undefined;

var _estore = require("./requests/estore");

var _createFetchRejection = require("./utilities/createFetchRejection");

var _createFetchRejection2 = _interopRequireDefault(_createFetchRejection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var cart = exports.cart = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apiBase) {
    var response, json;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _estore.cart)(apiBase);

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            json = _context.sent;

            if (!response.ok) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", {
              itemsInCart: json.totalUnitCount || 0,
              userName: json.userName
            });

          case 8:
            return _context.abrupt("return", (0, _createFetchRejection2.default)(response, json));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function cart(_x) {
    return _ref.apply(this, arguments);
  };
}();